import * as React from 'react';
import LegalTemplatesViewComponent from './../../components/Legal/LegalTemplatesTable';

import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

// Moved to module scope to avoid re-creating the styled component on every render
const Item = styled(Paper)(({theme}) => ({
    ...theme.typography.body2,
    padding: theme.spacing(3),
    backgroundColor: "#fffcf8",
    marginRight: 0,
    marginBottom: 20,
    textAlign: 'center',
    border: 'none',
    borderRadius: 0,
    boxShadow: '0',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: 'grey',
    }),
}));

export default function LegalPage(): React.ReactElement {

    return (
        <Grid container>
            <Grid size={12}>
                <Item>
                    <Box sx={{width: '100%', bgcolor: '#fffcf8'}}>
                        <LegalTemplatesViewComponent/>
                    </Box>
                </Item>
            </Grid>
        </Grid>
    )
}
